import { useEffect } from 'react'
import { useAppStore } from './app-store'

/**
 * Reads the persisted theme + locale and syncs them to <html>.
 * The initial flash is already prevented by the inline script in index.html;
 * this keeps the DOM in sync with React state on every change.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = useAppStore((s) => s.theme)
  const locale = useAppStore((s) => s.locale)

  useEffect(() => {
    const html = document.documentElement
    html.classList.toggle('dark', theme === 'dark')
    html.style.colorScheme = theme
  }, [theme])

  useEffect(() => {
    const html = document.documentElement
    html.lang = locale
    html.dir = locale === 'ar' ? 'rtl' : 'ltr'
  }, [locale])

  return <>{children}</>
}
